// ChannelModal.js - Modal başlığında kanal logosu ve adı gösteriliyor
import React, { useRef, useState, useEffect } from 'react';
import TagSelect from '../../TagSelect/TagSelect';
import './ChannelModal.css';
import { toast } from 'react-hot-toast';
import { useConfirmModal } from '../../../contexts/ConfirmModalContext';

import axios from 'axios';
import API_URL from '../../../config';

function ChannelModal({
    isOpen,
    onClose,
    channelForm,
    setChannelForm,
    onSubmit,
    onDelete,
    editingChannelId,
    tags,
    mtprotoStatus,
    channelType
}) {
    const formWrapperRef = useRef(null);

    // Context hook
    const { showConfirm } = useConfirmModal();

    // Bot kontrol state'leri
    const [botStatus, setBotStatus] = useState(null);
    const [checkingBot, setCheckingBot] = useState(false);
    const [addingBot, setAddingBot] = useState(false);

    // Profil fotoğrafı state'leri
    const [profilePhoto, setProfilePhoto] = useState(null);
    const [photoPreview, setPhotoPreview] = useState(null);
    const [uploadingPhoto, setUploadingPhoto] = useState(false);

    // Chat ID değiştiğinde otomatik kontrol
    useEffect(() => {
        if (channelForm.chat_id && !editingChannelId) {
            checkBotStatus();
        } else {
            setBotStatus(null);
        }
    }, [channelForm.chat_id]);

    // Modal kapandığında fotoğraf state'lerini temizle
    useEffect(() => {
        if (!isOpen) {
            setProfilePhoto(null);
            setPhotoPreview(null);
        }
    }, [isOpen]);

    // Modal kapatma (her zaman uyarı ver)
    const handleClose = () => {
        showConfirm(async () => {
            onClose();
        });
    };

    // Bot durumunu kontrol et
    const checkBotStatus = async () => {
        if (!channelForm.chat_id) return;

        setCheckingBot(true);
        try {
            const response = await axios.post(`${API_URL}/channels/check-bot-status`, {
                chat_id: channelForm.chat_id
            });

            setBotStatus(response.data);
        } catch (error) {
            console.error('Bot kontrol hatası:', error);
            setBotStatus({ error: true, message: error.message });
        } finally {
            setCheckingBot(false);
        }
    };

    // Bot'u otomatik ekle ve admin yap
    const handleAutoAddBot = async () => {
        setAddingBot(true);
        try {
            const response = await axios.post(`${API_URL}/channels/auto-add-bot`, {
                chat_id: channelForm.chat_id
            });

            if (response.data.success) {
                setBotStatus({
                    isInChannel: true,
                    isAdmin: true,
                    status: 'administrator'
                });

                toast.success(response.data.message || 'Bot başarıyla eklendi ve admin yapıldı!');

                setTimeout(() => {
                    checkBotStatus();
                }, 2000);

            } else {
                let errorMessage = response.data.error;

                if (response.data.requiresMTProto) {
                    errorMessage += '\n\n⚠️ MTProto Kurulumu Gerekli:\n' +
                        '1. my.telegram.org\'dan API ID ve Hash alın\n' +
                        '2. .env dosyasına TELEGRAM_API_ID ve TELEGRAM_API_HASH ekleyin\n' +
                        '3. TELEGRAM_PHONE_NUMBER\'ı ekleyin\n' +
                        '4. Sunucuyu yeniden başlatın';
                } else if (response.data.suggestion) {
                    errorMessage += '\n\n💡 Öneri: ' + response.data.suggestion;
                }

                toast.error(errorMessage, {
                    duration: response.data.requiresMTProto ? 8000 : 5000,
                    style: {
                        maxWidth: '500px',
                        padding: '16px',
                    }
                });

                setTimeout(() => {
                    checkBotStatus();
                }, 1000);
            }

        } catch (error) {
            console.error('Bot ekleme hatası:', error);
            toast.error('Bir hata oluştu: ' + error.message);
        } finally {
            setAddingBot(false);
        }
    };

    // Fotoğraf seçildiğinde önizleme
    const handlePhotoSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                toast.error('Dosya boyutu maksimum 5MB olmalıdır');
                e.target.value = null;
                return;
            }

            if (!file.type.startsWith('image/')) {
                toast.error('Sadece resim dosyaları yüklenebilir');
                e.target.value = null;
                return;
            }

            setProfilePhoto(file);

            const reader = new FileReader();
            reader.onloadend = () => {
                setPhotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Fotoğrafı yükle
    const handlePhotoUpload = async () => {
        if (!profilePhoto || !editingChannelId) return;

        setUploadingPhoto(true);

        const formData = new FormData();
        formData.append('photo', profilePhoto);

        try {
            const response = await axios.post(
                `${API_URL}/channels/${editingChannelId}/update-photo`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            if (response.data.success) {
                alert('✅ ' + response.data.message);

                setProfilePhoto(null);
                setPhotoPreview(null);

                const photoInput = document.getElementById('photo-upload');
                if (photoInput) photoInput.value = null;

                if (window.fetchChannelsGlobal) {
                    window.fetchChannelsGlobal();
                }

            } else {
                alert('❌ ' + response.data.error);
            }
        } catch (error) {
            console.error('Fotoğraf yükleme hatası:', error);
            toast.error('Fotoğraf yüklenemedi: ' + (error.response?.data?.error || error.message));
        } finally {
            setUploadingPhoto(false);
        }
    };

    // Fotoğrafı kaldır
    const handlePhotoRemove = () => {
        setProfilePhoto(null);
        setPhotoPreview(null);
        const photoInput = document.getElementById('photo-upload');
        if (photoInput) photoInput.value = null;
    };

    // SİLME FONKSİYONU
    const handleDelete = () => {
        if (!editingChannelId || !onDelete) return;

        const channelName = channelForm.name || 'Bu kanalı';

        toast((t) => (
            <div>
                <p style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                    "{channelName}" kanalını silmek istediğinizden emin misiniz?
                </p>
                <p style={{ fontSize: '13px', marginBottom: '5px' }}>⚠️ Bu işlem geri alınamaz!</p>
                <ul style={{ fontSize: '12px', margin: '5px 0', paddingLeft: '20px' }}>
                    <li>Kanal bilgileri silinecek</li>
                    <li>İstatistikler kaybolacak</li>
                    <li>Etiket ilişkileri kaldırılacak</li>
                </ul>
                <div style={{ marginTop: '15px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    <button
                        onClick={() => {
                            onDelete(editingChannelId);
                            toast.dismiss(t.id);
                            toast.success('Kanal başarıyla silindi');
                            onClose();
                        }}
                        style={{
                            padding: '8px 16px',
                            background: '#EF4444',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        Evet, Sil
                    </button>
                    <button
                        onClick={() => toast.dismiss(t.id)}
                        style={{
                            padding: '8px 16px',
                            background: '#6B7280',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer'
                        }}
                    >
                        İptal
                    </button>
                </div>
            </div>
        ), {
            duration: Infinity,
            position: 'top-center',
            style: {
                minWidth: '400px',
                background: '#FFF',
                color: '#000',
                padding: '20px'
            }
        });
    };

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (botStatus && !botStatus.isAdmin && !editingChannelId && !botStatus?.error) {
            toast('Bot henüz admin değil! Bot admin olmadan bazı özellikler çalışmayabilir.', {
                icon: '⚠️',
                duration: 5000,
                style: {
                    background: '#FFA500',
                    color: '#fff',
                }
            });
        }

        try {
            const dataToSend = {
                name: channelForm.name || 'Yeni Kanal',
                chat_id: channelForm.chat_id,
                description: channelForm.description || '',
                channel_tags: channelForm.channel_tags || []
            };

            if (editingChannelId) {
                const response = await axios.put(`${API_URL}/channels/${editingChannelId}`, dataToSend);
                if (response.data.success) {
                    toast.success('Kanal güncellendi!');
                    onSubmit(e);
                } else {
                    toast.error(response.data.error || 'Güncelleme başarısız');
                }
            } else {
                const response = await axios.post(`${API_URL}/channels`, dataToSend);
                if (response.data.success) {
                    if (response.data.updated) {
                        toast.success(`"${response.data.channelInfo.name}" kanalı güncellendi!`);
                    } else {
                        toast.success(`"${response.data.channelInfo?.name || 'Kanal'}" başarıyla eklendi!`);
                    }
                    onSubmit(e);
                } else {
                    toast.error(response.data.error || 'Ekleme başarısız');
                }
            }
        } catch (error) {
            console.error('Channel operation error:', error);
            toast.error(error.response?.data?.error || error.message || 'İşlem başarısız');
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && e.target.className === 'modal-backdrop') {
            handleClose();
        }
    };

    const handleTagSelectOpen = () => {
        setTimeout(() => {
            if (formWrapperRef.current) {
                const tagDropdown = formWrapperRef.current.querySelector('.tag-select-dropdown');
                if (tagDropdown) {
                    tagDropdown.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            }
        }, 100);
    };

    const isChannel = channelType === 'channel';
    const canChangeName = !isChannel || (mtprotoStatus && mtprotoStatus.connected);

    return (
        <div className="modal-backdrop" onMouseDown={handleBackdropClick}>
            <div className="modal-container" onMouseDown={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        {editingChannelId ? (
                            <>
                                {channelForm.photo_url ? (
                                    <img
                                        src={channelForm.photo_url}
                                        alt={channelForm.name}
                                        style={{
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            border: '2px solid #667eea',
                                            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.2)'
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            const span = document.createElement('span');
                                            span.style.fontSize = '24px';
                                            span.textContent = '📝';
                                            e.target.parentElement.replaceChild(span, e.target);
                                        }}
                                    />
                                ) : (
                                    <span style={{ fontSize: '24px' }}>📝</span>
                                )}
                                <span>{channelForm.name || 'Kanalı Düzenle'}</span>
                            </>
                        ) : (
                            '➕ Yeni Kanal Ekle'
                        )}
                    </h2>
                    <button className="modal-close" onClick={handleClose}>✕</button>
                </div>

                <div className="modal-form-wrapper" ref={formWrapperRef}>
                    <form onSubmit={handleSubmit} className="modal-form">

                        {/* KANAL ADI - SADECE DÜZENLEME MODUNDA */}
                        {editingChannelId && (
                            <div className="form-group">
                                <label>
                                    <span className="label-icon">📡</span>
                                    {isChannel ? 'Kanal' : 'Grup'} Adı
                                </label>
                                <input
                                    type="text"
                                    value={channelForm.name}
                                    onChange={(e) => setChannelForm({ ...channelForm, name: e.target.value })}
                                    required
                                    placeholder="Örn: Duyuru Kanalı"
                                    className={`form-input ${editingChannelId && isChannel && !canChangeName ? 'disabled-field' : ''}`}
                                    disabled={editingChannelId && isChannel && !canChangeName}
                                />
                            </div>
                        )}

                        {/* KANAL AÇIKLAMASI - SADECE DÜZENLEME MODUNDA */}
                        {editingChannelId && (
                            <div className="form-group">
                                <label>
                                    <span className="label-icon">📄</span>
                                    {isChannel ? 'Kanal' : 'Grup'} Açıklaması
                                </label>
                                <textarea
                                    value={channelForm.description || ''}
                                    onChange={(e) => {
                                        setChannelForm({ ...channelForm, description: e.target.value });
                                        e.target.style.height = 'auto';
                                        e.target.style.height = e.target.scrollHeight + 'px';
                                    }}
                                    onInput={(e) => {
                                        e.target.style.height = 'auto';
                                        e.target.style.height = e.target.scrollHeight + 'px';
                                    }}
                                    placeholder={`${isChannel ? 'Kanal' : 'Grup'} açıklamasını girin...`}
                                    className="form-textarea"
                                    maxLength="255"
                                    style={{
                                        minHeight: '60px',
                                        maxHeight: '200px',
                                        overflow: 'auto',
                                        resize: 'vertical',
                                        transition: 'height 0.2s ease'
                                    }}
                                    ref={(textarea) => {
                                        if (textarea) {
                                            textarea.style.height = 'auto';
                                            textarea.style.height = textarea.scrollHeight + 'px';
                                        }
                                    }}
                                />
                                <div className="character-count">
                                    {(channelForm.description || '').length}/255 karakter
                                </div>
                            </div>
                        )}

                        {/* PROFİL FOTOĞRAFI - SADECE DÜZENLEME MODUNDA */}
                        {editingChannelId && (
                            <div className="form-group">
                                <label>
                                    <span className="label-icon">📸</span>
                                    Profil Fotoğrafı
                                </label>

                                <div style={{
                                    border: '2px dashed #ddd',
                                    borderRadius: '8px',
                                    padding: '20px',
                                    textAlign: 'center',
                                    background: '#fff',
                                    transition: 'all 0.3s ease'
                                }}>
                                    {/* MEVCUT FOTOĞRAF GÖSTERME */}
                                    {!photoPreview && channelForm.photo_url && (
                                        <div>
                                            <div style={{
                                                marginBottom: '15px',
                                                fontSize: '14px',
                                                color: '#666',
                                                fontWeight: '500'
                                            }}>
                                                Mevcut Fotoğraf
                                            </div>
                                            <img
                                                src={channelForm.photo_url}
                                                alt="Mevcut profil fotoğrafı"
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                    marginBottom: '15px',
                                                    border: '3px solid #e0e0e0',
                                                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
                                                }}
                                                onError={(e) => {
                                                    e.target.style.display = 'none';
                                                    const fallback = document.createElement('div');
                                                    fallback.style.width = '150px';
                                                    fallback.style.height = '150px';
                                                    fallback.style.borderRadius = '50%';
                                                    fallback.style.background = '#f0f0f0';
                                                    fallback.style.display = 'flex';
                                                    fallback.style.alignItems = 'center';
                                                    fallback.style.justifyContent = 'center';
                                                    fallback.style.fontSize = '48px';
                                                    fallback.style.margin = '0 auto 15px';
                                                    fallback.textContent = '📷';
                                                    e.target.parentElement.replaceChild(fallback, e.target);
                                                }}
                                            />
                                            <div>
                                                <input
                                                    type="file"
                                                    accept="image/jpeg,image/jpg,image/png"
                                                    onChange={handlePhotoSelect}
                                                    style={{ display: 'none' }}
                                                    id="photo-upload"
                                                />
                                                <label
                                                    htmlFor="photo-upload"
                                                    style={{
                                                        display: 'inline-block',
                                                        padding: '10px 20px',
                                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                        color: 'white',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer',
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        transition: 'all 0.3s ease',
                                                        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.transform = 'translateY(-2px)';
                                                        e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.transform = 'translateY(0)';
                                                        e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                                                    }}
                                                >
                                                    🔄 Fotoğrafı Değiştir
                                                </label>
                                            </div>
                                        </div>
                                    )}

                                    {/* YENİ FOTOĞRAF SEÇİLDİĞİNDE */}
                                    {photoPreview && (
                                        <div>
                                            <div style={{
                                                marginBottom: '15px',
                                                fontSize: '14px',
                                                color: '#4caf50',
                                                fontWeight: '500'
                                            }}>
                                                Yeni Fotoğraf Önizleme
                                            </div>
                                            <img
                                                src={photoPreview}
                                                alt="Önizleme"
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover',
                                                    marginBottom: '15px',
                                                    border: '3px solid #667eea',
                                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                                }}
                                            />
                                            <div style={{
                                                marginBottom: '10px',
                                                fontSize: '13px',
                                                color: '#666'
                                            }}>
                                                {profilePhoto?.name} ({(profilePhoto?.size / 1024).toFixed(0)} KB)
                                            </div>
                                            <div>
                                                <button
                                                    type="button"
                                                    onClick={handlePhotoRemove}
                                                    style={{
                                                        padding: '8px 16px',
                                                        background: '#f44336',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        marginRight: '10px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#d32f2f';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = '#f44336';
                                                    }}
                                                >
                                                    ❌ İptal
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={handlePhotoUpload}
                                                    disabled={uploadingPhoto}
                                                    style={{
                                                        padding: '8px 16px',
                                                        background: uploadingPhoto ? '#ccc' : '#4caf50',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        cursor: uploadingPhoto ? 'not-allowed' : 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    {uploadingPhoto ? (
                                                        <>
                                                            <span className="spinner" style={{
                                                                display: 'inline-block',
                                                                width: '12px',
                                                                height: '12px',
                                                                border: '2px solid #fff',
                                                                borderTopColor: 'transparent',
                                                                borderRadius: '50%',
                                                                animation: 'spin 1s linear infinite',
                                                                marginRight: '5px',
                                                                verticalAlign: 'middle'
                                                            }}></span>
                                                            Yükleniyor...
                                                        </>
                                                    ) : (
                                                        <>📤 Telegram'a Yükle</>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* FOTOĞRAF YOKSA */}
                                    {!photoPreview && !channelForm.photo_url && (
                                        <div>
                                            <div style={{
                                                fontSize: '48px',
                                                marginBottom: '10px',
                                                opacity: 0.5
                                            }}>
                                                📷
                                            </div>
                                            <p style={{
                                                marginBottom: '15px',
                                                fontSize: '14px',
                                                color: '#999'
                                            }}>
                                                Henüz profil fotoğrafı yok
                                            </p>
                                            <input
                                                type="file"
                                                accept="image/jpeg,image/jpg,image/png"
                                                onChange={handlePhotoSelect}
                                                style={{ display: 'none' }}
                                                id="photo-upload-new"
                                            />
                                            <label
                                                htmlFor="photo-upload-new"
                                                style={{
                                                    display: 'inline-block',
                                                    padding: '10px 20px',
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.transform = 'translateY(-2px)';
                                                    e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = 'translateY(0)';
                                                    e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                                                }}
                                            >
                                                📸 Fotoğraf Ekle
                                            </label>
                                        </div>
                                    )}

                                    <div style={{
                                        marginTop: '15px',
                                        fontSize: '12px',
                                        color: '#666',
                                        borderTop: '1px solid #eee',
                                        paddingTop: '10px'
                                    }}>
                                        JPG veya PNG • Maksimum 5MB • 1:1 oran önerilir
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* CHAT ID - HER ZAMAN GÖRÜNÜR */}
                        <div className="form-group">
                            <label>
                                <span className="label-icon">🔑</span>
                                Chat ID
                            </label>
                            <input
                                type="text"
                                value={channelForm.chat_id}
                                onChange={(e) => setChannelForm({ ...channelForm, chat_id: e.target.value })}
                                required
                                placeholder="-1001234567890 veya @kanalusername"
                                className="form-input"
                                disabled={editingChannelId}
                            />

                            {/* BOT DURUM VE OTOMATİK EKLEME BÖLÜMÜ - SADECE YENİ EKLEMEDE */}
                            {!editingChannelId && channelForm.chat_id && (
                                <div className="bot-control-section" style={{
                                    marginTop: '15px',
                                    padding: '15px',
                                    borderRadius: '8px',
                                    background: checkingBot ? '#f5f5f5' :
                                        botStatus?.isAdmin ? '#e8f5e9' :
                                            botStatus?.isInChannel ? '#fff3e0' : '#ffebee',
                                    border: `2px solid ${checkingBot ? '#ddd' :
                                        botStatus?.isAdmin ? '#4caf50' :
                                            botStatus?.isInChannel ? '#ff9800' : '#f44336'
                                        }`,
                                    transition: 'all 0.3s ease'
                                }}>
                                    {checkingBot ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <div className="spinner" style={{
                                                display: 'inline-block',
                                                width: '20px',
                                                height: '20px',
                                                border: '3px solid #ddd',
                                                borderTopColor: '#667eea',
                                                borderRadius: '50%',
                                                animation: 'spin 1s linear infinite'
                                            }}></div>
                                            <p style={{ marginTop: '10px', color: '#666' }}>
                                                Bot durumu kontrol ediliyor...
                                            </p>
                                        </div>
                                    ) : botStatus?.error ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <p style={{ color: '#f44336', fontWeight: 'bold' }}>
                                                ❌ Kanal kontrol edilemedi
                                            </p>
                                            <p style={{ fontSize: '13px', color: '#666', marginTop: '5px' }}>
                                                {botStatus.message || 'Lütfen kanal ID\'sini kontrol edin'}
                                            </p>
                                            <button
                                                type="button"
                                                onClick={checkBotStatus}
                                                style={{
                                                    marginTop: '10px',
                                                    padding: '8px 16px',
                                                    background: '#667eea',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                🔄 Tekrar Dene
                                            </button>
                                        </div>
                                    ) : botStatus?.isAdmin ? (
                                        <div style={{ textAlign: 'center' }}>
                                            <p style={{
                                                color: '#4caf50',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                margin: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                gap: '8px'
                                            }}>
                                                <span style={{ fontSize: '20px' }}>✅</span>
                                                Bot admin olarak hazır!
                                            </p>
                                            <p style={{
                                                fontSize: '12px',
                                                color: '#666',
                                                marginTop: '5px'
                                            }}>
                                                Kanal başarıyla eklenebilir
                                            </p>
                                        </div>
                                    ) : botStatus ? (
                                        <div>
                                            <p style={{
                                                color: botStatus.isInChannel ? '#ff9800' : '#f44336',
                                                fontWeight: 'bold',
                                                marginBottom: '10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <span style={{ fontSize: '18px' }}>
                                                    {botStatus.isInChannel ? '⚠️' : '❌'}
                                                </span>
                                                {botStatus.isInChannel ?
                                                    'Bot kanalda ama admin değil' :
                                                    'Bot henüz kanalda değil'}
                                            </p>

                                            <button
                                                type="button"
                                                onClick={handleAutoAddBot}
                                                disabled={addingBot}
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    background: addingBot ? '#ccc' :
                                                        'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    cursor: addingBot ? 'not-allowed' : 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    transition: 'all 0.3s ease',
                                                    boxShadow: addingBot ? 'none' : '0 4px 15px rgba(102, 126, 234, 0.3)'
                                                }}
                                            >
                                                {addingBot ? (
                                                    <>
                                                        <div className="spinner" style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            border: '2px solid #fff',
                                                            borderTopColor: 'transparent',
                                                            borderRadius: '50%',
                                                            animation: 'spin 1s linear infinite'
                                                        }}></div>
                                                        Bot Ekleniyor...
                                                    </>
                                                ) : (
                                                    <>
                                                        <span style={{ fontSize: '18px' }}>🤖</span>
                                                        Bot'u Ekle
                                                    </>
                                                )}
                                            </button>

                                            {!addingBot && (
                                                <button
                                                    type="button"
                                                    onClick={checkBotStatus}
                                                    style={{
                                                        width: '100%',
                                                        marginTop: '8px',
                                                        padding: '8px',
                                                        background: 'transparent',
                                                        color: '#667eea',
                                                        border: '2px solid #667eea',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.target.style.background = '#667eea';
                                                        e.target.style.color = 'white';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.target.style.background = 'transparent';
                                                        e.target.style.color = '#667eea';
                                                    }}
                                                >
                                                    🔄 Durumu Kontrol Et
                                                </button>
                                            )}
                                        </div>
                                    ) : null}
                                </div>
                            )}

                            {/* Help Box */}
                            {(!botStatus || editingChannelId) && (
                                <div className="help-box">
                                    <div className="help-title">📌 ID Formatları:</div>
                                    <ul className="help-list">
                                        <li><strong>Public kanal:</strong> @kanalusername</li>
                                        <li><strong>Private kanal:</strong> -1001234567890</li>
                                        <li><strong>Sadece username:</strong> kanalusername</li>
                                    </ul>
                                    {editingChannelId && (
                                        <div className="help-info">
                                            ℹ️ Chat ID düzenleme modunda değiştirilemez
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ETİKETLER - HER ZAMAN GÖRÜNÜR */}
                        <div className="form-group">
                            <label>
                                <span className="label-icon">🏷️</span>
                                Etiketler
                            </label>
                            <div className="tag-select-wrapper">
                                <TagSelect
                                    selectedTags={channelForm.channel_tags}
                                    onChange={(selected) => setChannelForm({ ...channelForm, channel_tags: selected })}
                                    tags={tags}
                                    placeholder="Kanal kategorilerini seçin..."
                                    onOpen={handleTagSelectOpen}
                                />
                            </div>
                            <small className="form-hint">
                                Kanalı kategorize etmek için birden fazla etiket seçebilirsiniz
                            </small>
                        </div>

                        {/* YENİ KANAL EKLEME BİLGİ KUTUSU */}
                        {!editingChannelId && (
                            <div className="info-box" style={{
                                background: 'linear-gradient(135deg, #667eea15 0%, #764ba215 100%)',
                                border: '2px solid #667eea30',
                                borderRadius: '8px',
                                padding: '15px',
                                marginTop: '20px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginBottom: '10px'
                                }}>
                                    <span style={{ fontSize: '20px' }}>ℹ️</span>
                                    <strong>Otomatik Kanal Ekleme</strong>
                                </div>
                                <ul style={{
                                    margin: 0,
                                    paddingLeft: '20px',
                                    fontSize: '13px',
                                    color: '#555'
                                }}>
                                    <li>Chat ID girdiğinizde bot durumu kontrol edilir</li>
                                    <li>Kanal adı ve açıklaması Telegram'dan otomatik çekilir</li>
                                    <li>Üye sayısı ve kanal tipi otomatik belirlenir</li>
                                    <li>Bot yoksa tek tıkla ekleyebilirsiniz</li>
                                </ul>
                            </div>
                        )}
                    </form>
                </div>

                {/* FOOTER */}
                <div className="modal-footer">
                    <div className="footer-left">
                        {editingChannelId && onDelete && (
                            <button
                                type="button"
                                onClick={handleDelete}
                                className="delete-btn"
                                title="Bağlantıyı Kes"
                            >
                                Bağlantıyı Kes
                            </button>
                        )}
                    </div>

                    <div className="footer-right">
                        <button type="button" onClick={handleClose} className="btn-cancel">
                            İptal
                        </button>
                        <button
                            onClick={handleSubmit}
                            className="btn-submit"
                            disabled={!editingChannelId && botStatus && !botStatus.isAdmin && !botStatus?.error}
                        >
                            {editingChannelId ?
                                <><span>🔄</span> Güncelle</> :
                                <><span>➕</span> Ekle</>
                            }
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChannelModal;